@import 'styles/variables';

.placeholder {
  background: $gray-10;
  height: 100%;
  width: 100%;
  &.dark {
    background: $gray-20;
  }
  &.block {
    height: 16px;
    border-radius: 40px;
    width: 122px;
    + .block {
      margin-top: 8px;
    }
    &.bottom {
      margin-top: 24px;
    }
    &.large {
      width: 142px;
    }
  }
}
